var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserMenuArrowdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00AFF0",
    d: "M20.229,12.349l-5.038,5.039l-5.039-5.039c-0.339-0.339-0.892-0.339-1.232,0c-0.34,0.34-0.34,0.893,0,1.232 l5.653,5.651c0.17,0.172,0.395,0.257,0.618,0.256c0.224,0,0.447-0.084,0.62-0.256l5.65-5.651c0.34-0.339,0.34-0.893,0-1.232 C21.121,12.01,20.568,12.01,20.229,12.349z M15.253,2.191c-7.183,0-13.008,5.825-13.008,13.008 c-0.002,7.186,5.822,13.008,13.008,13.008c7.184,0,13.007-5.822,13.007-13.007C28.261,8.016,22.438,2.191,15.253,2.191L15.253,2.191 z M15.253,26.465c-6.21,0-11.265-5.055-11.265-11.265S9.043,3.936,15.253,3.936C21.463,3.934,26.518,8.989,26.518,15.2 C26.518,21.41,21.463,26.465,15.253,26.465z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMenuArrowdown);
export default __webpack_public_path__ + "static/media/user_menu_arrowdown.72c5d4ac5cedf947262616b6bd0fb35d.svg";
export { ForwardRef as ReactComponent };